import { observable, action, runInAction, computed } from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';

class ItemStore {
  constructor() {

  }

  init () {

  }

  /**
   * 控制 modal 是否显示
   */
  @observable
  is_modal_show = false;

  /**
   * 账户信息
   * @type {null}
   */
  @observable
  record = undefined;

  /**
   * 打开 modal 显示
   */
  @action
  openModal(record) {
    this.record = record;
    this.record.tempRadio = record.radio * 100;
    this.is_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeModal() {
    this.record = undefined;
    this.is_modal_show = false;
  }

  @action
  updateRecord(record){
    this.record = record;
  }


}

let item_store = new ItemStore();
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Agent/AgentDetailStore.js